import React from 'react';
import { enjoyCards } from './data';
import './Styles/Enjoy.scss';

const Enjoy=()=>{
    return(
        <div className="enjoy-about">
            <h1>We enjoy our work to the fullest</h1>
            <p>Table tennis is a part of our daily work. We play games and read books from our library to refresh
our minds and enjoy ourselves. When a new movie comes out, we head to the theaters. Besides
that, we often hangout and dine together.</p>
<div className="cards">
    {enjoyCards.map((d) =>{
        return(
            <Card {...d}/>
        )
    })}
</div>
        </div>
    )
};
export default Enjoy ;

export function Card(props){
    return(
        <div className="enjoy-card"  data-aos="fade-up"
        data-aos-delay={props.delay}>
            <div className="image-part" style={{ backgroundImage: `url(${props.backgroundImage})` }}></div>
            <p>{props.title}</p>
        </div>
    )
};
